import { render, staticRenderFns } from "./topicReply.vue?vue&type=template&id=863f4498&scoped=true"
import script from "./topicReply.vue?vue&type=script&lang=js"
export * from "./topicReply.vue?vue&type=script&lang=js"
import style0 from "./topicReply.vue?vue&type=style&index=0&id=863f4498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863f4498",
  null
  
)

export default component.exports